import { gql } from "@apollo/client";

export const CERRAR_PERIODO = gql`
mutation CerrarPeriodo($idPeriodo: Int!) {
    cerrarPeriodo(
        idPeriodo: $idPeriodo
    ) {
        idPeriodo
        mes
        ano
        activo
        fechaDesde
        fechaHasta
        fechaModificacion
        idUsuarioModificacion
    }
}`;